import { render, staticRenderFns } from "./NewCustomerModal.vue?vue&type=template&id=3ac6a818"
import script from "./NewCustomerModal.vue?vue&type=script&lang=js"
export * from "./NewCustomerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports